import "./style.scss";
import BubbleVideo from "../BubbleVideo";

export default function AppVideoCard({
  mobileImg,
  desktopImg,
  imgDesc,
  copy,
  points,
  brands,
  completed = false,
  ident,
  type,
  highlighted,
  href,
  date = null,
  className = "",
  description = "",
  disabled = false,
}) {
  return (
    <div className={`ultra-app-video-card ${disabled ? "disabled" : ""}`}>
      <div className="inner">
        <div className="img-wrapper">
          {/* {completed && type !== "Contest" && (
              <div className="award-link">
                <span>Punkte eintauschen</span> <ArrowTip />
              </div>
            )} */}
          <BubbleVideo />
        </div>
      </div>
    </div>
  );
}
